module.exports = __webpack_public_path__ + "static/media/3-1-krvi-potil.6c83d637.jpg";